import type { ReactNode } from 'react';
import { Link, Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom';
import { LibraryScreen } from './screens/LibraryScreen';
import { GameHubScreen } from './screens/GameHubScreen';
import { ManualScreen } from './screens/ManualScreen';
import { SectionScreen } from './screens/SectionScreen';
import { FirstGameScreen } from './screens/FirstGameScreen';
import { GuidedScreen } from './screens/GuidedScreen';
import { UpdatePrompt } from './components/UpdatePrompt';
import { getStorageInfo } from './adapters/persistence';
import { useGamePrefs } from './state/GamePrefsProvider';

function BackLink() {
  const location = useLocation();
  const { gameId } = useParams();
  if (location.pathname === '/') return null;
  if (location.pathname.startsWith('/game/') && location.pathname.split('/').length > 3) {
    return (
      <Link className="ghost-btn" to={`/game/${gameId}`}>
        ‹ Gra
      </Link>
    );
  }
  return (
    <Link className="ghost-btn" to="/">
      ‹ Biblioteka
    </Link>
  );
}

function Shell({ children }: { children: ReactNode }) {
  const info = getStorageInfo();
  const { ready } = useGamePrefs();
  const online = typeof navigator === 'undefined' ? true : navigator.onLine;

  return (
    <div className="app-shell">
      <div className="app-frame">
        <UpdatePrompt />
        <header className="top-bar">
          <div>
            <div className="brand">Planszówki</div>
            <div className="offline-pill" style={{ marginTop: 6 }}>
              {online ? 'Online' : 'Offline'} · {info.backend}
              {ready ? '' : ' · wczytywanie…'}
            </div>
          </div>
          <BackLink />
        </header>
        {children}
      </div>
    </div>
  );
}

export function AppPwa() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <Shell>
            <LibraryScreen />
          </Shell>
        }
      />
      <Route
        path="/game/:gameId"
        element={
          <Shell>
            <GameHubScreen />
          </Shell>
        }
      />
      <Route path="/game/:gameId/manual" element={<Navigate to="0" replace />} />
      <Route
        path="/game/:gameId/manual/:chapterIndex"
        element={
          <Shell>
            <ManualScreen />
          </Shell>
        }
      />
      <Route
        path="/game/:gameId/first-game"
        element={
          <Shell>
            <FirstGameScreen />
          </Shell>
        }
      />
      <Route
        path="/game/:gameId/guided"
        element={
          <Shell>
            <GuidedScreen />
          </Shell>
        }
      />
      <Route
        path="/game/:gameId/turn-helper"
        element={
          <Shell>
            <GuidedScreen />
          </Shell>
        }
      />
      <Route
        path="/game/:gameId/:section"
        element={
          <Shell>
            <SectionScreen />
          </Shell>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
